<template>
<div id="join-us">
      
      <div class="container">
        <div class="row">
          <div class="col-md-9">
            <span>Junte-se a nós e torne o mundo um lugar melhor!</span>
          </div>
          <div class="col-md-3">
            <router-link to="/signup" class="button" href="">Cadastre-se</router-link>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
export default {
  data(){
    return {
      
    }
  }
}
</script>

<style scoped lang="scss">
#join-us{
  background-color: #00AE39;
  min-height: 130px;

  span{
    display: block;
    height: 130px;
    line-height: 130px;
    font-size: 1.6em;
    color: #fff;
    font-family: RalewayRegular;
    @media screen and(max-width: 991px){
      font-size: 1.2em;
    }
    @media screen and(max-width: 767px){
      line-height: 20px;
      height: 25px;
      margin-top: 25px;
      text-align: center;
    }
  }

  .button{
    color: #fff;
    background-color: #00AE39;
    border: thin solid #fff;
    padding: 10px;
    border-radius: 20px;
    display: block;
    text-align: center;
    font-family: RalewayRegular;
    font-size: 20px;
    margin-top: 40px;
    text-decoration: none;
    @media screen and(max-width: 767px){
      margin-top: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/JoinSection.vue